import { render, staticRenderFns } from "./InvoicePublicLink.vue?vue&type=template&id=1030950f&scoped=true"
import script from "./InvoicePublicLink.vue?vue&type=script&lang=js"
export * from "./InvoicePublicLink.vue?vue&type=script&lang=js"
import style0 from "./InvoicePublicLink.vue?vue&type=style&index=0&id=1030950f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1030950f",
  null
  
)

export default component.exports